<div class='global-nav-container'>
    <div class="logo"><img src=""></div>
    <span class='welcome-title'></span>
</div>
<login-global-alert></login-global-alert>

<div data-automation="main-container" class="main-container">
    <router-outlet></router-outlet>
</div>
